module.exports = __webpack_public_path__ + "static/media/empty-state-mel.ff331339.svg";